class TermsApiError extends Error {
  constructor(response, data) {
    super('Terms request failed');
    this.response = { status: response.status, data };
  }
}

const parseResponse = async (response) => {
  const data = await response.json();
  if (!response.ok) throw new TermsApiError(response, data);
  return data;
};

export const getTermsMetadata = async (apiUrl) => {
  const response = await fetch(`${apiUrl}/users/terms-metadata`, {
    headers: { Accept: 'application/json' },
  });
  return parseResponse(response);
};

export const acceptCurrentTerms = async ({ apiUrl, token, metadata }) => {
  const response = await fetch(`${apiUrl}/users/me/terms-acceptance`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      requirementId: metadata.acceptanceRequirement.id,
      documentVersion: metadata.publishedDocument.version,
    }),
  });
  return parseResponse(response);
};
